import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_5e829dec from 'nuxt_plugin_plugin_5e829dec' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_2e518de3 from 'nuxt_plugin_pluginutils_2e518de3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_d3b3a324 from 'nuxt_plugin_pluginrouting_d3b3a324' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7bf103c1 from 'nuxt_plugin_pluginmain_7bf103c1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_2e27b82e from 'nuxt_plugin_gtm_2e27b82e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_6503cb5e from 'nuxt_plugin_vuesocialsharingplugin_6503cb5e' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_1f09fd80 from 'nuxt_plugin_moment_1f09fd80' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_breakpoint_08bc58b0 from 'nuxt_plugin_breakpoint_08bc58b0' // Source: ../plugins/breakpoint.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_betCalculations_54e82412 from 'nuxt_plugin_betCalculations_54e82412' // Source: ../plugins/betCalculations.js (mode: 'all')
import nuxt_plugin_sportsRadar_375392c6 from 'nuxt_plugin_sportsRadar_375392c6' // Source: ../plugins/sportsRadar.js (mode: 'client')
import nuxt_plugin_freshchat_1c4a1927 from 'nuxt_plugin_freshchat_1c4a1927' // Source: ../plugins/freshchat.js (mode: 'client')
import nuxt_plugin_vuecookies_6b36a0a5 from 'nuxt_plugin_vuecookies_6b36a0a5' // Source: ../plugins/vue-cookies.js (mode: 'client')
import nuxt_plugin_axiosinterceptor_d3021f42 from 'nuxt_plugin_axiosinterceptor_d3021f42' // Source: ../plugins/axios-interceptor.js (mode: 'client')
import nuxt_plugin_plugin_2c732694 from 'nuxt_plugin_plugin_2c732694' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"src":"https:\u002F\u002Fwchat.freshchat.com\u002Fjs\u002Fwidget.js","body":true}],"meta":[{"charset":"utf-8"},{"clearNuxtData":"0"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"cache-control","content":"max-age=86400"},{"http-equiv":"expires","content":"0"},{"name":"viewport","content":"user-scalable=0, width=device-width, height=device-height, initial-scale=1, maximum-scale=1"},{"name":"google-site-verification","content":"8HVwpc_nwKSuP6me34o8_rTU83aAdM476COavlgxr4w"},{"name":"p:domain_verify","content":"85e9412a6429015a4ddb9d0540055219"},{"name":"keywords","content":"live casino, premium sportsbook, sportsbook live, betting exchange, card games, games cricket"},{"name":"og:title","content":"Online Betting Site | Sports Betting in India | Fairplay"},{"name":"og:site_name","content":"Fairplay"},{"name":"og:url","content":"https:\u002F\u002Fthefairplay.io"},{"name":"og:type","content":"website"},{"name":"og:image","content":"https:\u002F\u002Fd1znekj6k2v12k.cloudfront.net\u002Fwebsite-logo.webp"},{"name":"og:description","content":"India’s Biggest and Most Trusted Online Betting Exchange. Instant Withdrawals & Deposits, Best odds, 24\u002F7 Customer Service and Referral Bonus."},{"key":"Strict-Transport-Security","value":"max-age=63072000; includeSubDomains"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ficon.png"},{"rel":"preconnect","href":"https:\u002F\u002Fd1znekj6k2v12k.cloudfront.net"},{"rel":"preconnect","href":"https:\u002F\u002Fwchat.in.freshchat.com"},{"rel":"preconnect","href":"https:\u002F\u002Fassetscdn-wchat.in.freshchat.com"},{"rel":"preconnect","href":"https:\u002F\u002Fs3.ap-south-1.amazonaws.com"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Lato:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5e829dec === 'function') {
    await nuxt_plugin_plugin_5e829dec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_2e518de3 === 'function') {
    await nuxt_plugin_pluginutils_2e518de3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d3b3a324 === 'function') {
    await nuxt_plugin_pluginrouting_d3b3a324(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7bf103c1 === 'function') {
    await nuxt_plugin_pluginmain_7bf103c1(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2e27b82e === 'function') {
    await nuxt_plugin_gtm_2e27b82e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6503cb5e === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6503cb5e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_1f09fd80 === 'function') {
    await nuxt_plugin_moment_1f09fd80(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoint_08bc58b0 === 'function') {
    await nuxt_plugin_breakpoint_08bc58b0(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_betCalculations_54e82412 === 'function') {
    await nuxt_plugin_betCalculations_54e82412(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sportsRadar_375392c6 === 'function') {
    await nuxt_plugin_sportsRadar_375392c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_freshchat_1c4a1927 === 'function') {
    await nuxt_plugin_freshchat_1c4a1927(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecookies_6b36a0a5 === 'function') {
    await nuxt_plugin_vuecookies_6b36a0a5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axiosinterceptor_d3021f42 === 'function') {
    await nuxt_plugin_axiosinterceptor_d3021f42(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2c732694 === 'function') {
    await nuxt_plugin_plugin_2c732694(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
